

























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({ components: { Toggle, List } })
export default class TextEditor extends Vue {
  @Prop() readonly type!: string;

  @Watch('company', { immediate: true, deep: true })
  companyChanged() {
    if (this.alwaysUpdate) { // TODO: Do not clear custom texts...
      if (this.text === undefined) {
        this.init();
      }
    }
  }

  init() {
    this.text = this.default;
  }

  get alwaysUpdate() {
    return this.type === 'webreport_cashflow_comment';
  }

  get active() {
    return this.text !== '';
  }

  get company() {
    return dokument.overview ? dokument.overview.OrgNr : '';
  }

  get texts() {
    return dokument.Texts;
  }

  get text() {
    const text = dokument.Texts[this.type];
    return text === undefined ? this.default : text;
  }

  set text(value: string) {
    if (value === this.default && !this.alwaysUpdate) {
      dokument.setText({ Type: this.type, Text: undefined });
    } else {
      dokument.setText({ Type: this.type, Text: value });
    }
  }

  get title() {
    switch (this.type) {
      case 'summary':
        return 'Sammanfattning';
      case 'recommendation':
        return 'Fokusområde';
      case 'webreport_cashflow_comment':
        return 'Kommentar';
      default:
        return '';
    }
  }

  get info() {
    switch (this.type) {
      case 'summary':
        return 'Rapporten inleds med en automatisk summering. Om du önskar redigera denna görs detta nedan.';
      case 'recommendation':
        return 'Rapporten avslutas med ett valt fokusområde som baseras på ditt val under avsnittet "Analys" i presentationsmallen. Det generereras automatisk en generell text som du kan redigera nedan.';
      case 'webreport_cashflow_comment':
        return 'Presentationen avslutas med kommentar. Det generereras automatisk en generell text som du kan redigera nedan.';
      default:
        return '';
    }
  }

  get default() {
    // TODO: Create a text module

    const f = this.$options.filters;
    let o;
    let cf;
    let pl;
    let b;
    let b1;

    switch (this.type) {

      case 'summary':
        if (
          !f ||
          !dokument.cashflow ||
          !dokument.profitloss ||
          !dokument.balance
        ) {
          return '';
        }
        cf = dokument.cashflow.sheets[0];
        pl = dokument.profitloss.sheets[0];
        b = dokument.balance.sheets[0];

        const res = `Analysen visar att de totala kassaflödena för perioden ${
          cf.DATE_FROM
        } till ${cf.DATE_TO} uppgick till ${f.KRP(
          cf.CashFlow,
        )} vilket ledde till att den utgående balansen för kassa & bank hamnade på ${f.KRP(
          b.J,
        )}. De operativa kassaflödena för samma tidsperiod uppgick till ${f.KRP(
          cf.OperatingCashflow,
        )} vilket motsvarar ${f.P(
          cf.OperatingCashflow / pl.A,
        )} av bolagets nettoomsättning på ${f.KRP(pl.A)}.`;
        return res;

      case 'recommendation':
        const section = dokument.getItem(2007);
        switch (section.SubType) {
          case 'cashflowRecommendation_daytoday':
            return 'Rekommendationen framgent är att bolaget bör fokusera sina ansträngningar på att förbättra kassaflödena från den löpande verksamheten. Genom att nå goda kassaflöden från den löpande verksamheten kommer det finnas möjligheter för bolaget att satsa på att utveckla verksamheten och samtidigt berika ägarna.';
          case 'cashflowRecommendation_workingcapital':
            return 'Rekommendationen framgent är att bolaget bör fokusera sina ansträngningar på att se över bindningen av rörelsekapital. Genom att effektivisera rörelsekapitalet kommer likviditet att frigöras som kan hjälpa bolaget att utveckla verksamheten ytterligare.';
          case 'cashflowRecommendation_investments':
            return 'Rekommendationen framgent är att bolaget bör fokusera sina ansträngningar på att se över utfallet av sina investeringar. Genom att förbättra utfallet från investeringarna kommer likviditeten att förbättras vilket kan hjälpa bolaget utveckla sin verksamhet och samtidigt berika ägarna.';
          case 'cashflowRecommendation_financing':
            return 'Rekommendationen framgent är att bolaget bör fokusera sina ansträngningar på att hitta rätt finansieringsupplägg. Genom att hitta rätt finansieringsmix kan bolaget utveckla sin verksamhet och samtidigt förbättra situationen för ägarna.';
        }
        return '';

      case 'webreport_cashflow_comment':
        if (
            !f ||
            !dokument.overview ||
            !dokument.cashflow ||
            !dokument.profitloss ||
            !dokument.balance
        ) {
          return this.company;
        }
        o = dokument.overview;
        cf = dokument.cashflow.sheets[0];
        pl = dokument.profitloss.sheets[0];
        b = dokument.balance.sheets[0];
        b1 = dokument.balance.sheets[1];

        let comment = '';

        if (cf.OperatingCashflow < 0) { // NEGATIVT operativt kassaflöde
          comment += `Att bolagets operativa kassaflöden är negativa innebär att ${o.NAME} inte går runt på sin egen verksamhet vilket kan vara riskabelt då det ställer krav på en stor kassa eller extern finansiering.\n\n`;
          if (cf.OperatingCashflow < b.J * -0.5) {
            comment += `Med nuvarande burn-rate kommer bolagets kassa & bank vara slut om ungefär ${f.D0(f.ABS(b.J / (cf.OperatingCashflow / 12)))} månader från ${cf.DATE_TO} och om inte en kraftig vändning har skett bör det vara av högsta prioritet för bolaget att tillföra externt kapital inom kort för att inte riskera att hamna i likviditetsmässiga trångmål.\n\n`;
          } else {
            comment += `${o.NAME} är välfinansierat och med nuvarande burn-rate kan man köra på ett par år till utan störning, men man bör säkerställa en plan för att på sikt nå ett positivt operativt kassaflöde så att man inte är lika beroende av tillkommande ägarfinansiering.\n\n`;
          }
        } else if (cf.OperatingCashflow > 0) { // POSITIVT operativt kassaflöde
          if (cf.OperatingCashflow / pl.A < 0.025) { //  Operativt kassaflöde mellan 0 och 2,5 % av nettoomsättningen
            if (b.U + b.P === 0) { // Saknar räntebärande skulder
              if (b.J / pl.A > 0.1) { // Har en kassa som är större än 10 % av nettoomsättningen
                comment += `För ${o.NAME} är den operativa kassaflödesmarginalen låg vilket bekymrar, men i och med att man inte har några räntebärande skulder till externa långivare och en tämligen solid kassa & bank så bör bolaget ha manöverutrymme för att se över sina processer och fokusera på att effektivisera verksamheten för att därigenom kunna hitta en bra väg framåt för att på sikt förhoppningsvis kunna förbättra de operativa kassaflödena.\n\n`;
              }
            }
          } else if ((b.U + b.P) !== 0 && (b.U + b.P) < (b1.P + b1.U)) { // Färdig med amorteringar inom ett år
            comment += `Om ${o.NAME} fortsätter att betala av sina räntebärande skulder i samma takt som den senaste perioden kommer bolaget att bli skuldfritt under det kommande året vilket bör stärka kassa & bank och/eller ge möjlighet att frigöra kassaflöden för andra aktiviteter än att betala långivarna.\n\n`;
          }
        } else {
          comment += `Bolaget har varken positivt eller negativt kassaflöde. Knasigt!\n\n`;
        }

        return comment;

      default:
        return '';
    }
  }
}
